import React from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {checkQueryKey, formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";
import {useQueryForehead} from "@/service/forehead.s";

export const ViewForehead = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: foreheadData, isLoading: foreheadLoading} = useQueryForehead({id: drawerId!}, checkQueryKey(drawerId))
    const forehead = foreheadData?.data

    return <> <ResultWrapper isLoading={foreheadLoading} isEmpty={isEmpty(forehead)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'发票抬头'} content={forehead?.invoiceTitle}/>
                <GridItem title={'纳税识别号'} content={forehead?.taxNumber}/>
                <GridItem title={'开户行'} content={forehead?.depositBank}/>
                <GridItem title={'开户账户'} content={forehead?.depositAccount}/>
                <GridItem title={'联系电话'} content={forehead?.mobile}/>
                <GridItem title={'电子邮箱'} content={forehead?.email}/>
                <GridItem minHeight={'48px'} size={12} title={'开户地址'} content={forehead?.depositAddress || '-'}/>

                <GridItem title={'创建人'} content={formatTime('D', forehead?.creator)}/>
                <GridItem title={'创建时间'} content={formatTime('D', forehead?.createdAt)}/>
            </Grid>
        </Stack>
    </ResultWrapper>
    </>
}